import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { getStorage } from '@utils/localStorage';
import { RootState } from '../../store';
import { IQuerySubMenuItem } from '../../api/define';
import styles from './MenuTag.module.scss';

type MenuTagProps = {
    menuName: string;
    menuCode: string;
    mask: string;
    pageHash: string;
    /** 待处理订单tag数 */
    unprocessedOrderCount: number;
    /** 商品tag数 */
    lowQualitySpusCount: number;
    subMenus?: IQuerySubMenuItem[];
};

const { useMemo } = React;

/** 导航栏tag */
const MenuTag: React.FC<MenuTagProps> = ({
    menuName,
    menuCode,
    mask,
    pageHash,
    unprocessedOrderCount,
    lowQualitySpusCount,
    subMenus,
}) => {
    // 展示“热” | “新” 的菜单
    const hotOrNewTag = useMemo(() => {
        const cacheMenus = getStorage('clickedAll') || '';
        if (
            ['订单管理', '店铺装修', '开门营业'].includes(menuName) ||
            menuCode === 'Ori.ProductManage' ||
            cacheMenus.indexOf(menuName) > -1
        ) {
            return false;
        }
        return true;
    }, [menuName, menuCode, subMenus, pageHash]);

    // 二级菜单中展示“热” || "新" 的数量
    const subMenuHotNewNum = useMemo(() => {
        const cacheMenus = getStorage('clickedAll') || '';
        let filterList = [];
        if (subMenus && subMenus.length) {
            filterList = subMenus.filter(item => {
                return (
                    (item.mask === 'hot' || item.mask === 'new') &&
                    cacheMenus.indexOf(item.subMenuName) === -1
                );
            });
        }
        return filterList.length;
    }, [menuName, mask, subMenus, pageHash]);

    const parentMenuTag = useCallback(() => {
        if (!subMenus) return null;
        if (subMenuHotNewNum > 1) {
            return <span className={styles.badgeDot} />;
        } else if (subMenuHotNewNum === 1) {
            return <span className={styles.badgeNewHot}>新</span>;
        } else if (mask) {
            return <span className={styles.badgeNewHot}>{mask === 'hot' ? '热' : '新'}</span>;
        }
        return null;
    }, [subMenuHotNewNum, subMenus, pageHash, mask]);

    const subMenuTag = useCallback(() => {
        if (!hotOrNewTag || subMenus || !mask) return null;
        return <span className={styles.badgeNewHot}>{mask === 'hot' ? '热' : '新'}</span>;
    }, [hotOrNewTag, subMenus, mask]);

    if (
        ['Ori.Order', 'Sub.WMOrderUnprocessedNew', 'Sub.WMOrderUnprocessedNewModel'].includes(
            menuCode,
        )
    ) {
        return unprocessedOrderCount > 0 ? (
            <span className={styles.badgeDanger}>
                {unprocessedOrderCount <= 99 ? unprocessedOrderCount : '99+'}
            </span>
        ) : null;
    } else if (['Ori.ProductManage', 'Sub.WMProductHelper'].includes(menuCode)) {
        return lowQualitySpusCount > 0 ? (
            <span className={styles.badgeDanger}>
                {lowQualitySpusCount <= 99 ? lowQualitySpusCount : '99+'}
            </span>
        ) : null;
    } else if (menuName === '店铺装修') {
        return <span className={styles.specialIcon}>零售版</span>;
    } else if (menuName === '开门营业') {
        return <span className={styles.waitOpen}>待开门</span>;
    } else {
        const pMenuTag = parentMenuTag();
        const sMenuTag = subMenuTag();

        if (pMenuTag !== null) {
            return pMenuTag;
        } else {
            return sMenuTag;
        }
    }
};

const mapStateToProps = (state: RootState) => {
    return {
        pageHash: state.mainContent.pageHash,
        unprocessedOrderCount: state.orderCount.total,
        lowQualitySpusCount: state.shellLeftMenu.lowQualitySpusCount,
    };
};

export default connect(mapStateToProps)(MenuTag);
